import * as React from 'react';
import { ReactNode, useState } from 'react';

import { cn } from '@blockworks/ui';

import styles from './ticker.module.css';

export type TickerItemType = {
    name: string;
    value: number | null;
    percentage: number | null;
    type: string;
};

type TickerProps = {
    children: ReactNode;
    sponsor?: ReactNode;
    className?: string;
};

const TopBarTicker = ({ children, sponsor, className }: TickerProps) => {
    const [paused, setPaused] = useState(false);

    const childArray = React.Children.toArray(children);

    return (
        <div className={cn('w-full', className)}>
            <div
                className="relative overflow-hidden w-full h-[24px]"
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
                role="marquee"
                aria-live="off"
            >
                <div
                    className={`flex absolute top-0 left-0 h-full items-center whitespace-nowrap gap-4 ${styles.tickerTrack} ${
                        paused ? styles.tickerPaused : ''
                    }`}
                >
                    {childArray}
                    {sponsor && <div className="flex items-center justify-center">{sponsor}</div>}

                    {childArray.map((child, idx) =>
                        React.isValidElement(child)
                            ? React.cloneElement(child, {
                                  // eslint-disable-next-line
                                  key: `clone-${idx}`,
                              })
                            : child,
                    )}
                </div>
            </div>
        </div>
    );
};

export default TopBarTicker;
